module.exports = __webpack_public_path__ + "static/media/2.1cf14717.JPG";